import React, { useState, useEffect } from 'react';
import { callAction } from '../lib/odoo.js';

// ─── Choix de l'emplacement réel (liste Odoo, sans caméra) ───
export function LocationPicker({ product, onPick, onCancel, question = 'Où as-tu pris le produit ?', libelleOk = 'J’ai pris ici' }) {
  const [locs, setLocs] = useState(null);
  const [sel, setSel] = useState(null);      // emplacement choisi
  const [lot, setLot] = useState(null);      // lot choisi (si le produit en a)
  const [query, setQuery] = useState('');
  const [found, setFound] = useState([]);
  const [autre, setAutre] = useState(false);
  const pid = product.product_id || product.id;

  useEffect(() => {
    callAction('getProductStockLocations', { productId: pid }).then(setLocs).catch(() => setLocs([]));
  }, [pid]);
  useEffect(() => {
    if (!autre || query.trim().length < 2) { setFound([]); return; }
    const t = setTimeout(() => callAction('searchLocations', { query }).then(setFound).catch(() => setFound([])), 300);
    return () => clearTimeout(t);
  }, [query, autre]);

  const shortName = (product.name || '').includes(']') ? product.name.split(']').slice(1).join(']').trim() : product.name;
  const btn = (active, color) => ({ width: '100%', textAlign: 'left', padding: '10px 12px', borderRadius: 9, border: '1.5px solid ' + (active ? color : '#E2E2E8'), background: active ? '#EAF6EE' : 'white', cursor: 'pointer', fontFamily: 'inherit', marginBottom: 6 });

  return (
    <div style={{ padding: 14, borderRadius: 10, background: '#F0FDF4', border: '2px solid #1E6B3C', marginBottom: 8 }}>
      <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 2 }}>{shortName}</div>
      <div style={{ fontSize: 13, fontWeight: 700, color: '#1E6B3C', marginBottom: 8 }}>{question}</div>

      {locs === null && <div style={{ fontSize: 12, color: '#888' }}>Lecture du stock Odoo…</div>}
      {locs && !autre && (
        <>
          {locs.length === 0 && <div style={{ fontSize: 12, color: '#C0392B', marginBottom: 6 }}>Odoo n'a ce produit nulle part en stock.</div>}
          {locs.map(l => (
            <button key={l.location_id} onClick={() => { setSel(l); setLot(null); }} style={btn(sel?.location_id === l.location_id, '#1E6B3C')}>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#1A1D23' }}>{l.location_name}</div>
              <div style={{ fontSize: 11, color: '#666' }}>{l.qty} en stock{l.reserved ? ' · ' + l.reserved + ' réservé' : ''}{l.lots.length ? ' · ' + l.lots.length + ' lot' + (l.lots.length > 1 ? 's' : '') : ''}</div>
            </button>
          ))}
          <button onClick={() => setAutre(true)} style={{ ...btn(false, '#888'), color: '#666', fontSize: 12 }}>🔎 Autre emplacement (pas dans la liste)…</button>
        </>
      )}
      {autre && (
        <>
          <input autoFocus value={query} onChange={e => setQuery(e.target.value)} placeholder="Code ou nom de l'emplacement…" style={{ width: '100%', padding: '10px 12px', borderRadius: 9, border: '1.5px solid #E2E2E8', fontSize: 14, fontFamily: 'inherit', boxSizing: 'border-box', marginBottom: 6 }} />
          {found.map(l => (
            <button key={l.id} onClick={() => { setSel({ location_id: l.id, location_name: l.complete_name || l.name, lots: [], horsStock: true }); setLot(null); }} style={btn(sel?.location_id === l.id, '#1E6B3C')}>
              <div style={{ fontSize: 13, fontWeight: 700 }}>{l.complete_name || l.name}</div>
              <div style={{ fontSize: 11, color: '#B7791F' }}>Odoo n'a pas ce produit ici : un responsable vérifiera le stock</div>
            </button>
          ))}
          <button onClick={() => { setAutre(false); setQuery(''); setSel(null); }} style={{ ...btn(false, '#888'), color: '#666', fontSize: 12 }}>← Revenir à la liste</button>
        </>
      )}

      {sel && sel.lots && sel.lots.length > 0 && (
        <div style={{ marginTop: 6 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: '#1A5276', marginBottom: 4 }}>Quel lot as-tu pris ?</div>
          {sel.lots.map(l => (
            <button key={l.lot_id} onClick={() => setLot(l)} style={btn(lot?.lot_id === l.lot_id, '#1A5276')}>
              <span style={{ fontSize: 13, fontWeight: 700 }}>{l.lot_name}</span> <span style={{ fontSize: 11, color: '#666' }}>· {l.qty} en stock</span>
            </button>
          ))}
        </div>
      )}

      <button disabled={!sel || (sel.lots && sel.lots.length > 0 && !lot)} onClick={() => onPick(sel, lot)} style={{
        width: '100%', marginTop: 8, padding: 14, borderRadius: 10, border: 'none',
        background: (!sel || (sel.lots && sel.lots.length > 0 && !lot)) ? '#9CA3AF' : '#1E6B3C', color: 'white', fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
      }}>✅ {libelleOk}{sel ? ' : ' + sel.location_name : ''}{lot ? ' · lot ' + lot.lot_name : ''}</button>
      <button onClick={onCancel} style={{ width: '100%', marginTop: 6, padding: 8, borderRadius: 8, border: '1px solid #E2E2E8', background: 'white', color: '#888', fontSize: 11, cursor: 'pointer', fontFamily: 'inherit' }}>← Retour</button>
    </div>
  );
}
